var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-dialog-form',{ref:"listLocationDialog",attrs:{"title":_vm.$t('sport_facilities')+' '+_vm.asdCode,"color":"secondary","icon":"mdi-earth"}},[_c('DataTables',{attrs:{"headers":_vm.headers,"tableData":_vm.tableData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }